import { createContext, useContext } from 'react';
import type { AuthContextValue } from './auth-context.types';

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export const useIDPContext = (): AuthContextValue => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useIDPContext must be used within a GuardProvider');
  }
  return context;
};
